var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select"},[_c('v-button',{staticClass:"select__button",attrs:{"primary":"","to":{ name: 'login-owner' }}},[_vm._v("Собственник")]),_c('v-button',{attrs:{"to":{ name: 'login-staff' }}},[_vm._v("Агент")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }